import * as actions from './transferWorkOrder/actions'
import * as mutations from './transferWorkOrder/mutations'
import * as getters from './transferWorkOrder/getters'

import { dataProps } from './transferWorkOrder/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
search_term_array: []
    },
    do_not_load_by_default: false,
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/transferWorkOrder.js